<template>
  <v-container class="p-insure px-0">
    <v-layout row class="mt-2">
      <v-flex grow>
        <!-- 投保 -->
        <CSection title="保单" class="insure-card">
          <h3>订单号：{{policy.orderCode}}</h3>
          <v-form ref="form" lazy-validation class="form">
            <!-- 投保信息 -->
            <section class="form-section">
              <p class="mb-4">投保信息</p>
              <v-layout>
                <v-flex class="form-item">
                  <label>生效日期</label>
                  <!-- 只能选择明天-明天30天以内的时间 -->
                  <v-menu
                    ref="dateMenu"
                    v-model="effectBeginDateMenuVisible"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    :disabled="true"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      class="date-input"
                      v-model="form.effectBeginDate"
                      :solo="solo"
                      :rules="rules.effectBeginDate"
                      append-icon="calendar_today"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="form.effectBeginDate"
                      :header-date-format="date=>date"
                      :min="minEffectBeginDate"
                      no-title
                      @input="effectBeginDateMenuVisible = false"
                    ></v-date-picker>
                  </v-menu>
                  <p class="time">自{{policy.insureStartDate}}起至{{policy.insureEndDate}}止</p>
                </v-flex>
              </v-layout>
            <v-flex class="form-item form-item-left">
                <label>保障期限</label>
                <v-select :disabled="true" v-model="form.effectDuration" :items="effectDurationList" :solo="solo"></v-select>
            </v-flex>
              <InsurancePlanTable
                v-model="form.amount"
                :employees="employees"
                :code="policy.productId"
                :allRes="planAllList"
                :plan-id="form.productPlanId"
                :effect-duration="form.effectDuration"
                :orderList.sync="policy"
              />
            </section>
            <hr class="line">
          </v-form>
        <div>
            总保费
            <span class="display-1 primary-text">￥{{ form.amount.toFixed(2) }}</span>
        </div>
        </CSection>
        <CSection title="已投保人员" class="insure-card">
            <v-data-table :headers="newheaders" :items="items" hide-actions class="employee-table">
                <template slot="items" slot-scope="props">
                    <tr>
                    <td>
                        <p>{{props.item.name}}</p>
                    </td>
                    <td>
                        <p>{{props.item.jobName}}</p>
                    </td>
                    <td>
                        <p>{{props.item.identifyNumber}}</p>
                    </td>
                    <td>
                        <p>{{policy.insureStartDate}}</p>
                    </td>
                    <td>
                        <p>{{policy.insureEndDate}}</p>
                    </td>
                    </tr>
                </template>
            </v-data-table>
             <v-btn
                :loading="downloading"
                color="primary"
                block
                @click="downFile"
            >下载</v-btn>
        </CSection>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import InsurancePlanTable from "@/components/Order/orderInsureTable";
import areaList from '@/assets/js/area';

export default {
  components: {
    InsurancePlanTable,
  },
  props: {
    policy: Object,
  },
  data() {
    return {
        planAllList:{},
        downloading:false,
      areaList:areaList,
      solo: true,
      effectDurationList: [
        { text: "1年", value: 12 },
        { text: "10个月", value: 10 },
        { text: "9个月", value: 9 },
        { text: "8个月", value: 8 },
        { text: "7个月", value: 7 },
        { text: "6个月", value: 6 },
        { text: "5个月", value: 5 },
        { text: "4个月", value: 4 },
        { text: "3个月", value: 3 },
        { text: "2个月", value: 2 },
        { text: "1个月", value: 1 }
      ],
      newheaders: [
        {
          text: "被保险人姓名",
          value: "name",
          sortable: false
        },
        {
            text: "职业类别",
            value: "jobName",
            sortable: false
        },
        {
          text: "身份证号",
          value: "identifyNumber",
          sortable: false
        },
        {
          text: "保险起期",
          value: "insureStartDate",
          sortable: false
        },
        {
          text: "保险止期",
          value: "insureEndDate",
          sortable: false
        },
      ],
      items: [],
      formValid: true,
      form: {
        // 生效日期
        effectBeginDate: "",
        // 保障期限
        effectDuration: 12,
        // 产品方案，现在只有方案D了
        productPlanId: 4,
        agree: false,
        amount: 0,
      },
      rules: {
        effectBeginDate: [v => !!v || "请选择生效日期"]
      },
      // 生效日期选择菜单是否可见
      effectBeginDateMenuVisible: false,
      // 最小生效日期 T+3
      minEffectBeginDate: "",
      employees: [],
      //保障方案列表,由 Plan 组件实时传递
      loading: false,
        //投保下载地址
        downloadEmployeeUrl: "/app/api/heshunbao/downloadEmployee",
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    this.$store.dispatch("getUserInfo");
    this.form.effectBeginDate = this.policy.insureStartDate;
    this.form.effectDuration = this.policy.insurancePeriodUnit == 3?12:this.policy.insurancePeriod
    this.employees = this.policy.policyDetailList
    this.planAllList = this.policy
    this.items = this.policy.insuredList
  },
    mounted() {
        if (this.policy.productId === 2017){
            this.effectDurationList = [
                { text: "1年", value: 12 },
                { text: "11个月", value: 11 },
                { text: "10个月", value: 10 },
                { text: "9个月", value: 9 },
                { text: "8个月", value: 8 },
                { text: "7个月", value: 7 },
                { text: "6个月", value: 6 },
                { text: "5个月", value: 5 },
                { text: "4个月", value: 4 },
                { text: "3个月", value: 3 },
                { text: "2个月", value: 2 },
                { text: "1个月", value: 1 }
            ];
            this.downloadEmployeeUrl = "/app/api/heshunbao/b/downloadEmployee";
        }
    },
  methods: {
      downFile(){
        this.downloading = true
        const elink = document.createElement("a");
        elink.style.display = "none";
        elink.href = process.env.VUE_APP_API_URL+this.downloadEmployeeUrl+'?orderCode='+this.policy.orderCode;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        this.$axios.get(this.downloadEmployeeUrl+'?orderCode='+this.policy.orderCode).then(()=>{
            this.downloading = false
        }).catch(()=>{
            this.downloading = false
        })
      }
  }
};
</script>


<style lang="scss">
$form-item-left-width: 284px;
$form-item-label-width: 84px;
$label-margin-right: 20px;
$input-width: $form-item-left-width - $form-item-label-width -
  $label-margin-right;
  .time{
    font-size: 14px;
    color: $primary-color;
    margin-top: 7px;
    margin-left: 7px;
  }
.p-insure {
  .insure-card {
    .form-section {
      padding: 30px 137px 12px 0;
    }
    .plan-section {
      padding: 40px 0;
      .form-item {
        width: 240px !important;
        .plan-section-label {
          width: 56px;
        }
      }
    }
    .form {
      .form-item {
        label {
          width: $form-item-label-width;
          text-align: right;
        }
      }
      .form-item-left {
        width: $form-item-left-width;
        flex-grow: 0;
        .date-input {
          width: $input-width;
        }
      }
      .form-item-btn-mb {
        margin-bottom: 28px;
      }
      .form-item-btn-wrap {
        width: $input-width;
        .v-btn {
          margin: 0;
        }
      }
    }
  }
  .right-section {
    width: 330px;
    margin-left: 20px;
    .pay-card {
      margin: 0;
      width: 330px;
      padding: 50px 25px;
      font-size: 14px;
      .line {
        margin: 20px 0;
      }
      .checkbox {
        margin-top: -4px;
      }
      .pay-btn {
        margin-top: 30px;
        height: 50px;
      }
    }
  }
}
</style>
